import { styled } from 'styled-components';

export const ComponentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 3.75rem;
`;

export const ComponentsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 450px;
`;
